import { useEffect, useRef } from "react";

const useDidMountWithTimeout = (func, deps, delay) => {
	const didMount = useRef(false);

	useEffect(() => {
		if (didMount.current) {
			const timeOutId = setTimeout(() => {
				func();
			}, delay);
			return () => clearTimeout(timeOutId);
		} else didMount.current = true;
	}, deps);
};

export default useDidMountWithTimeout;
